<script>
  import { createEventDispatcher } from 'svelte';

  import Layout from 'lt-layout';

  export let layout;
  export let values;
  export let selected = false;

  let face = 'front';
  let h;
  let heigth;

  const message = ({ detail }) => {
    if (detail.type === 'toggle') {
      heigth = heigth || h;
      face = face === 'front' ? 'back' : 'front';
    } else {
      dispatch('message', detail);
    }
  }

  const dispatch = createEventDispatcher();
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div class={ $$props.class } class:selectable={ layout.selectable } class:selected={ selected } bind:offsetHeight={ h } style={ heigth ? `height: ${ heigth }px;` : undefined } on:click={ () => { if (layout.selectable) dispatch('message', { type: 'clicked' }) } }>
  <Layout layout={ layout[face] } { values } on:message={ message } />
</div>